/**
 * Created by Andrey Popov on 9/22/25.
 */

const LevelContentPasteHandler = function () { };

LevelContentPasteHandler.prototype.isApplicable = function (clipboardData) {
    if (!LevelContentCopyHandler.isContextApplicable()) {
        return false;
    }

    const data = this._extractData(clipboardData);
    return data && data.meta && data.meta.type === "LevelContent";
};

LevelContentPasteHandler.prototype.countItems = function () {
    return 1;
};

LevelContentPasteHandler.prototype.paste = function (clipboardData) {
    const levelContent = this._extractData(clipboardData).data;

    const adminEpisode = cleverapps.administrator.adminEpisodes.getActive();
    const episodeNo = adminEpisode.episodeNo;

    cleverapps.administrator.adminLevels.processEpisodeContent(episodeNo, (content) => {
        content.levels.push(levelContent);
    }, () => {
        cleverapps.notification.create("Paste level from clipboard");
    });
};

LevelContentPasteHandler.prototype._extractData = function (clipboardData) {
    let data = undefined;
    try {
        data = JSON.parse(clipboardData);
    } catch (e) {
        console.log(e);
        return false;
    }
    return data;
};

ClipboardService.REGISTERED_PASTE_HANDLERS.push(LevelContentPasteHandler);